export enum LockCardStage {
  LockCard = 'LockCard',
}

export interface LockCardState {
  stage: LockCardStage.LockCard
  cardId: string
}
